import { useGetRawConfig, useUpdateRawConfig } from '@src/emp-3.0/api/queryHooks';
import { message, Spin } from 'antd';
import React, { useEffect } from 'react';
import JsonEditor from '../JsonEditor';

const InsensitiveCCSConfiguration = () => {
  const { data, isLoading: isLoadingGetRawConfig, refetch } = useGetRawConfig();
  const { mutate: updateRawConfig, isLoading: isLoadingUpdateRawConfig } = useUpdateRawConfig();

  useEffect(() => {
    refetch();
  }, [refetch]);

  const handleSave = (payload) => {
    updateRawConfig(
      { payload },
      {
        onSuccess: () => {
          message.success({
            content: (
              <div style={{ textAlign: 'left' }}>
                Update success!
                <br />
                Sensors may take up to 5 minutes to reflect changes.
              </div>
            ),
            duration: 5,
          });
        },
        onError: (error: any) => {
          message.error(error?.response?.data?.msg);
        },
      },
    );
  };

  return (
    <Spin spinning={isLoadingGetRawConfig || isLoadingUpdateRawConfig}>
      <JsonEditor data={data} refetch={refetch} handleSave={handleSave} height={'90vh'} />
    </Spin>
  );
};

export default InsensitiveCCSConfiguration;
